import { SxProps, Theme } from '@mui/material';

export const styles: Record<'container' | 'icon' | 'chart', SxProps<Theme>> = {
  chart: { height: 48, left: 0, position: 'absolute', top: 0, width: 48 },
  container: { height: 48, position: 'relative', width: 48 },
  icon: { height: 20, left: 14, position: 'absolute', top: 14, width: 20 },
};
